
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as confirm_45emailDQF2RzDxBgMeta } from "/data/www/musikum_portal/prod/.app/pages/auth/confirm-email.vue?macro=true";
import { default as forgot_45password3SvIFb8RByMeta } from "/data/www/musikum_portal/prod/.app/pages/auth/forgot-password.vue?macro=true";
import { default as loginAApQoePPd6Meta } from "/data/www/musikum_portal/prod/.app/pages/auth/login.vue?macro=true";
import { default as signup7FEqj9gOrAMeta } from "/data/www/musikum_portal/prod/.app/pages/auth/signup.vue?macro=true";
import { default as billingHhAdjsJsWIMeta } from "/data/www/musikum_portal/prod/.app/pages/billing.vue?macro=true";
import { default as classesR6HeX9OlN2Meta } from "/data/www/musikum_portal/prod/.app/pages/classes.vue?macro=true";
import { default as inboxYNpQW5r3hwMeta } from "/data/www/musikum_portal/prod/.app/pages/inbox.vue?macro=true";
import { default as indexWuWQ777pMQMeta } from "/data/www/musikum_portal/prod/.app/pages/index.vue?macro=true";
import { default as invoicesCjyK1zkmpyMeta } from "/data/www/musikum_portal/prod/.app/pages/invoices.vue?macro=true";
import { default as portfolio20Qu7djtLuMeta } from "/data/www/musikum_portal/prod/.app/pages/portfolio.vue?macro=true";
import { default as prescriptionHUbuSgMNVoMeta } from "/data/www/musikum_portal/prod/.app/pages/prescription.vue?macro=true";
import { default as profileR8BCscCWpGMeta } from "/data/www/musikum_portal/prod/.app/pages/profile.vue?macro=true";
import { default as accountOSwbAIntmhMeta } from "/data/www/musikum_portal/prod/.app/pages/settings/account.vue?macro=true";
import { default as display225poAWAObMeta } from "/data/www/musikum_portal/prod/.app/pages/settings/display.vue?macro=true";
import { default as indexAxNV99eqUAMeta } from "/data/www/musikum_portal/prod/.app/pages/settings/index.vue?macro=true";
import { default as _91id_93OKDysjKy2JMeta } from "/data/www/musikum_portal/prod/.app/pages/settings/student/[id].vue?macro=true";
import { default as addN1QFQCUZliMeta } from "/data/www/musikum_portal/prod/.app/pages/settings/student/add.vue?macro=true";
import { default as settingslLZKErhHYCMeta } from "/data/www/musikum_portal/prod/.app/pages/settings.vue?macro=true";
import { default as validate_45dataMFQsD3ybzEMeta } from "/data/www/musikum_portal/prod/.app/pages/validate-data.vue?macro=true";
export default [
  {
    name: "auth-confirm-email",
    path: "/auth/confirm-email",
    meta: confirm_45emailDQF2RzDxBgMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/auth/confirm-email.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: forgot_45password3SvIFb8RByMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginAApQoePPd6Meta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/auth/login.vue")
  },
  {
    name: "auth-signup",
    path: "/auth/signup",
    meta: signup7FEqj9gOrAMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/auth/signup.vue")
  },
  {
    name: "billing",
    path: "/billing",
    meta: billingHhAdjsJsWIMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/billing.vue")
  },
  {
    name: "classes",
    path: "/classes",
    meta: classesR6HeX9OlN2Meta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/classes.vue")
  },
  {
    name: "inbox",
    path: "/inbox",
    meta: inboxYNpQW5r3hwMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/inbox.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexWuWQ777pMQMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/index.vue")
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: invoicesCjyK1zkmpyMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/invoices.vue")
  },
  {
    name: "portfolio",
    path: "/portfolio",
    meta: portfolio20Qu7djtLuMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/portfolio.vue")
  },
  {
    name: "prescription",
    path: "/prescription",
    meta: prescriptionHUbuSgMNVoMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/prescription.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profileR8BCscCWpGMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/profile.vue")
  },
  {
    name: settingslLZKErhHYCMeta?.name,
    path: "/settings",
    meta: settingslLZKErhHYCMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/settings.vue"),
    children: [
  {
    name: "settings-account",
    path: "account",
    meta: accountOSwbAIntmhMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/settings/account.vue")
  },
  {
    name: "settings-display",
    path: "display",
    meta: display225poAWAObMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/settings/display.vue")
  },
  {
    name: "settings",
    path: "",
    meta: indexAxNV99eqUAMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/settings/index.vue")
  },
  {
    name: "settings-student-id",
    path: "student/:id()",
    meta: _91id_93OKDysjKy2JMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/settings/student/[id].vue")
  },
  {
    name: "settings-student-add",
    path: "student/add",
    meta: addN1QFQCUZliMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/settings/student/add.vue")
  }
]
  },
  {
    name: "validate-data",
    path: "/validate-data",
    meta: validate_45dataMFQsD3ybzEMeta || {},
    component: () => import("/data/www/musikum_portal/prod/.app/pages/validate-data.vue")
  }
]